import type { KyInstance } from 'ky';

import { ensureError } from '@enterprise/core';

import type { RunBilling } from '#billing/types/run-billing.type';

import { Uri } from '#constants/uri';

/**
 * Triggers the billing report generation by sending a POST request to the billing API.
 *
 * @param instance - The Ky HTTP client instance used to make the request.
 * @param item - The billing data payload conforming to the `RunBilling` type.
 * @returns A promise that resolves with the response from the billing API.
 * @throws Will throw an error if the request fails.
 */
export const runBilling = async (instance: KyInstance, item: RunBilling) => {
  try {
    return await instance
      .post(Uri.billing.triggerBillingReport, {
        json: item,
      })
      .json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
